export class RequestResult extends Array {
    httpStatusCode: number;
    json: string;
}


export class UpdatedGISValue {
    name: string;
    originalValue: string;
    correctedValue: string;

    get isCorrected(): boolean {
        if (this.originalValue == null || this.originalValue === "") return false;
        return this.originalValue.toString().toLocaleUpperCase() !== this.correctedValue.toString().toLocaleUpperCase();
    }

    constructor(valueName: string, original: string, corrected: string) {
        this.name = valueName;
        this.originalValue = original;
        this.correctedValue = corrected;
    }

    toString(): string {
        let corrected: string = this.correctedValue != null && this.correctedValue.toString().length > 0 ? this.correctedValue : "[blank]";
        return `${this.name} changed from ${this.originalValue} to ${corrected}.`;
    }
}